/**
 * AutoCount — routes shown on the public (pre-login) navbar.
 * Kept empty on purpose: the sign-in page should stay focused.
 */

const pageRoutes: any[] = [];

export default pageRoutes;
